import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { selectCurrentModal } from "@state/selectors/app.selectors";

@Component({
  selector: "app-support-button",
  templateUrl: "./support-button.component.html",
  styleUrls: ["./support-button.component.scss"]
})
export class SupportButtonComponent {
  anyModalOpen = this.store.selectSignal(selectCurrentModal);

  constructor(private store: Store) {}
}
